<template>
  <div id="hellow">
    <header style="position: fixed;">
      <router-link to="/" style="color: white; font-size: 26px;">SCM系统</router-link>
      <div class="inner">
        <h2 style="margin: auto;color: white;"> <router-link to="EstablishmentRegistration">企业注册</router-link></h2><br>//小益帮查
        <h2 style="margin: auto;color: darkorange;">供应链大数据服务平台</h2>
        <!-- <router-link to="pagination">打印</router-link> -->

        <!-- <router-link to="database">小益帮查</router-link>
        <router-link to="audit">审核</router-link>
        <router-link to="menuBar">菜单</router-link> -->
        <!-- <div v-for="item in setIH" style="height: 40px;">
          <span class="word-t"><a style="color:white" :href="item.links">{{ item.names }}</a></span>
          <span class="divider"></span>
        </div> -->
      </div>
    </header>
    <div class="registbox">
      <el-form ref="form" :model="sizeForm" label-width="80px" size="mini" class="myform">
        <el-form-item label="账号:">
          <el-input v-model="sizeForm.user" placeholder="请输入账号" class="myinput"></el-input>
        </el-form-item>
        <el-form-item label="密码:">
          <el-input placeholder="请输入密码" v-model="sizeForm.pwd" show-password class="myinput"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button type="primary" @click="login()">登录</el-button>
          <el-button @click="regist" style="margin-left: 1rem;">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
    <footer style="position: fixed;">
      <strong>Copyright © 2020-2023</strong>


      <a href='https://beian.miit.gov.cn/' target="view_window">沪ICP备2023021369号-1 </a>
      <i class="el-icon-office-building" style="color: black; margin-right: 0px;"></i>上海孜益供应链科技有限公司地址：上海市青浦区徐泾镇徐乐路333弄9号1419室
      <i class="el-icon-phone" style="color: black;    margin-right: 0px;"></i> 021-56998880
      <!-- <div style="float: right!important;color: #606266;    padding-top: 0.25rem;"> <b>版本：</b>  {{edition}}</div> -->


    </footer>


  </div>
</template>
<script>
  import {
    LoginView,
    edition
  } from '../../static/API/API.js'
  export default {
    name: 'login',
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validatetel = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入电话'));
        } else {
          if (this.ruleForm.tel !== '') {
            this.$refs.ruleForm.validateField('tel');
          }
          callback();
        }
      };
      var validateusername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          if (this.ruleForm.username !== '') {
            this.$refs.ruleForm.validateField('username');
          }
          callback();
        }
      };
      var validatenames = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入姓名'));
        } else {
          if (this.ruleForm.name !== '') {
            this.$refs.ruleForm.validateField('name');
          }
          callback();
        }
      };
      return {
        edition:edition,
        options: [],
        value: '',
        option2: [],
        value2: '',
        sizeForm: {
          user: '',
          pwd: '',
          department: ''
        },
        drawer: false,
        direction: 'btt',
        labelPosition: 'left',
        ruleForm: {
          names: '',
          username: '',
          pass: '',
          checkPass: '',
          tel: '',
          company: '',
          positions: '',
        },
        rules: {
          username: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          names: [{
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            },
            {
              min: 2,
              max: 5,
              message: '长度在 2 到 5 个字符',
              trigger: 'blur'
            }
          ],
          pass: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }],
          tel: [{
            required: true,
            message: '请输入电话号',
            trigger: 'blur'
          }]
        },
        setIH: [],
        show: false,
      }
    },
    mounted() {
      // document.onkeydown = e => {
      //   if ((window.event ? e.keyCode : e.which) == 13) {
      //     this.login()
      //   }
      // }
      if(this.$route.query.account){
        this.loginTO()
      }
    },
    methods: {
      loginTO(){
        let account = this.$route.query.account
        let password = this.$route.query.password
        let params = new URLSearchParams();
        params.append('account', account);
        params.append('password', password);
        this.$axios.post(LoginView, params).then(res => {
          sessionStorage.setItem('password', password)
          sessionStorage.setItem('name', res.data[0].name)
          sessionStorage.setItem('companyid', res.data[0].companyid_FK_id)
          sessionStorage.setItem('user_id', res.data[0].GZL_SCM_USER_id_PK)
          this.$message({
            message: '切换用户登录成功',
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.$router.push('home')
        })
      },
      regist() {
        this.$router.push('right');
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      login() {
        // this.$router.push('/home')
        let that = this
        let formModels = this.sizeForm
        if (formModels.user.trim() == '' || formModels.pwd.trim() == '') {
          alert("账号密码不能为空")
          return
        }
        let params = new URLSearchParams();
        params.append('account', formModels.user);
        params.append('password', formModels.pwd);
        this.$axios.get(LoginView, {
          params
        }).then(res => {
          if (res.data.length == 1) {
            sessionStorage.setItem('password', formModels.pwd)
            sessionStorage.setItem('name', res.data[0].name)
            sessionStorage.setItem('companyid', res.data[0].companyid_FK_id)
            sessionStorage.setItem('user_id', res.data[0].GZL_SCM_USER_id_PK)
            this.$router.push('home')
            this.$message({
              message: '登录成功',
              type: 'success',
              duration: 1000,
              showClose: true,
            });
          } else {
            this.$message({
              message: res.data,
              type: 'warning',
              duration: 1000,
              showClose: true,
            });
          }

        })
      },
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #hellow {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    /* padding-top: 40px; */
    /* padding-bottom: 40px; */
    background: url(../../static/images/index.jpg) no-repeat;
    background-size: 100% 100%;
    font-size: 1rem;
  }
  .registbox {
    background-image: url(../../static/images/indexJQ.jpg);
    background-repeat: no-repeat;
    background-size: inherit ;
    opacity: 0.8;
    width: 31.875rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue